import './home.css';
import React from 'react';
import { Grid } from '@material-ui/core';
import Button from 'components/Styled/Button/Button';
import { Link } from 'react-router-dom';

function Home() {
    return (
        <div id='home_container'>
            <header />
            <Link to='/room' >
                <Button id='home_play_btn'>Jouer gratuitement</Button>
            </Link>
            <div id='home_page'>
                <div id='home_centerContent'>
                    <Grid container spacing={5}>
                        <Grid item sm={6} key='game_desc'>
                            <div className='home_game_info_container'>
                                <h2 className='home_title'>Description du jeu</h2>
                                <hr />
                                <p>
                                    Mafia de Cuba est un jeu de société crée par Loïc Lamy et Philippe des Pallières,
                                    édité par "Lui-même". <br />
                                    Ce site n'est que la version en ligne développé
                                    par <a href='https://admandev.fr' target='_blank'>Admandev</a>, un jeune développeur
                                    qui a été séduit par le jeu.<br /><br />
                                    Si vous aussi aimez ce jeu, vous pouvez acheter la version physique et soutenir les auteurs.
                                    <br /><br />
                                    <u>Infos sur le jeu physique :</u>
                                    <br /><br />
                                    Graphisme et illustrations: Tom Vuarchex
                                    <br /><br />
                                    Direction artistique et direction de collection : Philippe des Pallières assisté de Thomas Cosnefroy
                                    <br /><br />
                                    Maquette et fabrication: Caroline Ottavis assistée d’Angelina Costamagna
                                    <br /><br />
                                    Promotion et les animations de ce jeu: l’équipe d’Asmodee
                                    <br /><br />
                                    Editions « lui-même », septembre 2015, première édition
                                </p>
                                <a
                                    className='home_link'
                                    href='https://www.amazon.fr/Asmodee-Jeux-dambiance-Mafia/dp/B07CRHNRWV'
                                    target='_blank'
                                    rel="noreferrer"
                                >
                                    <Button color='secondary'>Acheter le jeu</Button>
                                </a>
                            </div>
                        </Grid>
                        <Grid id='home_principe' item sm={6} key='game_principle'>
                            <div className='home_game_info_container'>
                                <h2 className='home_title'>Principe</h2>
                                <hr />
                                <p>
                                    La Havane, 29 décembre 1955. A la fin du repas offert à ses « fidèles » hommes de main,
                                    Don Alessandro évoque les « affaires » en cours quand retentit le téléphone de l’arrière salle du restaurant.
                                    Le parrain est convoqué au bureau du président Batista. Il confie sa précieuse boîte à cigares à ses sbires.
                                    Il faut dire que celle-ci possède un double fond, sous un premier rang de cigares se trouve une cachette remplie
                                    de diamants !
                                    <br /><br />
                                    Dans le jeu Mafia de Cuba, un joueur incarne le Parrain et confie sa boite à cigares au joueur à sa gauche
                                    qui démarre le tour. La boite passe ensuite de main en main. En s'emparant de la boite, chaque joueur
                                    profite de l'occasion pour s'emparer de 1 ou plusieurs diamants ou de prendre un jeton Personnage.
                                    <br /><br />
                                    Dans la seconde phase, le Parrain interroge les joueurs pour identifier les voleurs et retrouver ses diamants.
                                    Immanquablement l'interrogatoire provoque des débats houleux et des déductions périlleuses,
                                    le Parrain retrouvera-t-il tous ses diamants avec l'aide de ses fidèles ?
                                    Perdra-t-il son honneur en accusant à tort ? Le plus rusé des voleurs l'emportera-t-il ?
                                    Ou est ce la CIA qui enverra tous ces malfrats sous les verrous ?
                                </p>
                                <a
                                    className='home_link'
                                    href='http://jeuxstrategie1.free.fr/jeu_mafia/regle.pdf'
                                    target='_blank'
                                    rel="noreferrer"
                                >
                                    <Button color='secondary'>Découvrez les règles du jeu</Button>
                                </a>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
    )
}

export default Home;
